import React, { useState } from "react";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";

import {
  Card,
  Grid2,
  Stack,
  Select,
  Checkbox,
  MenuItem,
  IconButton,
  Pagination,
  Box,
  Typography,
} from "@mui/material";

import {
  LoadingMore,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
  NewAssignmentPopup,
} from "components";

import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";

import graph from "../graph";
import Model from "./Model";
import Search from "./Search";

import Filter from "./Filter";

import FCM from "./FCM";
import Create from "./Create";
import CreateBulk from "./CreateBulk";
import AssignRole from "./AssignRole";
import AssignGroup from "./AssignGroup";
import MoreProvider from "./MoreProvider";
import PerPage from "./PerPage";
import Report from "./Report";
import Download from "./Download";

export default function List({
  page,
  limit,
  total,
  setPage,
  setLimit,

  result,
  refetch,
  loading,

  title,
  isPopup,
  onClose,

  isAssign,
  onAssign,
  assigning,
  multiSelect,

  selectable,
  setSelectable,

  filter,
  setFilter,
  clearFilter,
  preSelected,
}) {
  const [selected, setSelected] = useState(preSelected || []);
  const { userInfo, activeRole } = useSelector((state) => state.auth);
  const isAdmin = hasRequiredRole(["superadmin"], userInfo?.roles);
  const isDemo = Boolean(+activeRole?.is_demo)

  const handleSelect = (item) => {
    const selectedIndex = selected.map((item) => item.id).indexOf(item.id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    if (isAssign && !multiSelect && newSelected.length > 0) {
      onAssign([newSelected.reverse()[0]], onClose);
      setSelected([newSelected.reverse()[0]]);
      return;
    }
    return setSelected(newSelected);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(result);
      return;
    }
    setSelected([]);
  };

  const clearSelection = () => setSelected([]);

  const handleSelectable = () =>
    setSelectable((prev) => {
      if (prev) {
        clearSelection();
      }
      return !prev;
    });

  const refresh = () => {
    clearSelection();
    refetch();
  };

  const acception = result.length;
  const selection = selected.length;
  const count = Math.ceil(total / limit);

  return (
    <>
      <NewDialogTitle title={title} onClose={onClose} isPopup={isPopup} />
      <NewDialogContent isPopup={isPopup}>
        <Stack flex={2} overflow="scroll" position="relative">
          <ActionBar>
            {!isAssign && (
              <Stack
                borderRadius={2}
                direction="row"
                alignItems="center"
                bgcolor="action.hover"
              >
                {selectable && (
                  <Checkbox
                    size="small"
                    color="secondary"
                    onChange={handleSelectAllClick}
                    checked={acception > 0 && selection === acception}
                    indeterminate={selection > 0 && selection < acception}
                  />
                )}
                <IconButton onClick={handleSelectable}>
                  {selectable ? (
                    <LockRoundedIcon fontSize="small" color="action" />
                  ) : (
                    <LockOpenRoundedIcon fontSize="small" color="action" />
                  )}
                </IconButton>
              </Stack>
            )}
            <Search
              init={filter}
              setFilter={setFilter}
              clearFilter={clearFilter}
            />
            <Box flexGrow={1} />
            <Filter
              init={filter}
              setFilter={setFilter}
              clearFilter={clearFilter}
            />
            <Report filter={filter} />
            <Download
              filter={filter}
              url="https://core.dordent.com/api/user_export"
            />
          </ActionBar>
          <Stack flexGrow={1} overflow="scroll" position="relative">
            <Grid2 container spacing={2} pt={1} pb={2} px={2}>
              {result.length > 0 ? (
                result.map((model, index) => (
                  <Model
                    key={index}
                    size={{ xs: 12, sm: !isPopup && 6, md: !isPopup && 4 }}
                    model={model}
                    refetch={refetch}
                    isAssign={isAssign}
                    selectable={selectable}
                    delay={((index + 1) / limit) * (limit * 100)}
                    checked={
                      selected.find((select) => model.id === select.id)
                        ? true
                        : false
                    }
                    handleSelect={() =>
                      handleSelect({
                        id: model?.id,
                        title: `${model?.firstname} ${model?.lastname}`,
                      })
                    }
                  />
                ))
              ) : loading ? (
                <Grid2 size={{ xs: 12 }}>
                  <Typography align="center" variant="body2">در حال جستجو...</Typography>
                </Grid2>
              ) : (
                <Grid2 size={{ xs: 12 }}>
                  <Typography align="center" variant="body2">موردی یافت نشد</Typography>
                </Grid2>
              )}
            </Grid2>
          </Stack>
        </Stack>
        <Stack
          px={1}
          py={0.5}
          direction="row"
          alignItems="center"
          bgcolor="action.hover"
          justifyContent="space-between"
        >
          <Pagination
            size="small"
            page={page}
            count={count}
            siblingCount={1}
            boundaryCount={1}
            shape="rounded"
            color="primary"
            sx={{ borderRadius: 1 }}
            onChange={(e, value) => setPage(value)}
          />
          <PerPage limit={limit} setLimit={setLimit} />
        </Stack>

        {isAssign && multiSelect && (
          <NewAssignmentPopup
            graph={graph}
            title={title}
            onClose={onClose}
            onAssign={onAssign}
            selected={selected}
            assigning={assigning}
            handleSelect={handleSelect}
          />
        )}
      </NewDialogContent>
      <NewDialogActions isPopup={isPopup}>
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          columnGap={0.5}
        >
          {/* <MoreProvider> */}
          <IconButton
            size="small"
            color="default"
            onClick={refresh}
            loading={loading}
            sx={{ bgcolor: "action.hover" }}
          >
            <RefreshRoundedIcon color="inherit" fontSize="small" />
          </IconButton>

          {/* <CreateBulk title="createBulk" refetch={refresh} /> */}
          <AssignRole ids={selected} title="AssignRole" refetch={refresh} />
          <AssignGroup ids={selected} title="AssignGroup" refetch={refresh} />
          {/* <FCM ids={selected} title="fcm" refetch={refresh} /> */}
          {/* </MoreProvider> */}
          <Box flexGrow={1} />
          {!isDemo && <Create refetch={refresh} mode={filter.mode} />}

          {/* {!isAssign && (
            <Stack
              borderRadius={2}
              direction="row"
              alignItems="center"
              bgcolor="action.hover"
            >
              {selectable && (
                <Checkbox
                  size="small"
                  color="warning"
                  onChange={handleSelectAllClick}
                  checked={acception > 0 && selection === acception}
                  indeterminate={selection > 0 && selection < acception}
                />
              )}
              <IconButton onClick={handleSelectable}>
                {selectable ? (
                  <LockRoundedIcon fontSize="small" color="error" />
                ) : (
                  <LockOpenRoundedIcon fontSize="small" color="primary" />
                )}
              </IconButton>
            </Stack>
          )} */}
        </Stack>
      </NewDialogActions>
    </>
  );
}

function ActionBar({ children }) {
  return (
    <Stack
      p={2}
      top={0}
      zIndex={1}
      height={56}
      columnGap={1}
      width="100%"
      direction="row"
      position="sticky"
      bgcolor="transparent"
      alignItems="center"
    >
      {children}
    </Stack>
  );
}
